import { APP_DEFAULT } from './constants'

export const defaultSeBarConfigOptions = {
  apiFallbackUrl: '/se-api',
  app: APP_DEFAULT,
  hideSwitcher: false,
  loggedIn: false,
  mobileNav: false,
  mobileNavToggle: undefined,
  mobileNavClose: undefined,
  on: undefined,
  onInit: undefined,
  orgId: undefined,
  pageMode: 'normal',
  signOutUrl: `${_URLS.userService}/oauth/sign_out`,
  signInUrl: `${_URLS.userService}/users/sign_in`,
  teamId: undefined,
  theme: undefined,
}

const buildConfig = {
  urls: _URLS,
  firebase: _FIREBASE,
  stream: _STREAM,
}

const config = Object.assign({}, defaultSeBarConfigOptions, buildConfig, window.nginBarConfig, window.seBarConfig)

export default config
